import { render, staticRenderFns } from "./RatingInput.vue?vue&type=template&id=40d166dc"
import script from "./RatingInput.vue?vue&type=script&lang=js"
export * from "./RatingInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d166dc')) {
      api.createRecord('40d166dc', component.options)
    } else {
      api.reload('40d166dc', component.options)
    }
    module.hot.accept("./RatingInput.vue?vue&type=template&id=40d166dc", function () {
      api.rerender('40d166dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/RatingInput.vue"
export default component.exports